/**
 * Quick Add Button Component
 *
 * A floating action button (FAB) for quickly adding new accomplishments.
 * Appears in the bottom-right corner on all screens.
 */

import { Plus } from 'lucide-react';

interface QuickAddButtonProps {
  onClick: () => void;
}

export function QuickAddButton({ onClick }: QuickAddButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="
        fixed bottom-6 right-6 z-40
        flex items-center justify-center
        w-14 h-14 rounded-full
        bg-primary text-white
        shadow-warm-lg hover:shadow-warm-xl
        transition-all duration-200
        hover:bg-primary-dark hover:scale-105
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2
        active:scale-95
      "
      aria-label="Add new accomplishment"
    >
      <Plus className="h-6 w-6" aria-hidden="true" />
    </button>
  );
}
